"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADV_DEFAULT_BROWSER = exports.TRANSACTION_ACCOUNT_WRITE = exports.SHIP_TO_PARTY_WRITE = exports.PAYMENT_METHOD_ON_TERM_WRITE = exports.PAYMENT_METHOD_DEFAULT_WRITE = exports.INVOICE_GROUP_WRITE = exports.ENTITLEMENT_MANAGE = exports.BILLING_ADMIN_WRITE = exports.BILLING_ADMIN_MANAGE = exports.BILL_TO_PARTY_WRITE = exports.BILL_TO_PRICING_ELIGIBILITY_WRITE = exports.FINANCE_USER = exports.DEAL_DESK = exports.UPDATE_ADD_ON_SUBSCRIPTIONS = exports.EXPORT_CONTROLS_WRITE = exports.STAFFID_LOGIN = exports.COUPONS_WRITE = exports.COUPONS_READ = exports.CLOUD_SITE_PRODUCTS_DEACTIVATION = exports.CASSI_DISTURBED = exports.CASSI_ADMIN = void 0;
exports.CASSI_ADMIN = 'CASSI_ADMIN';
exports.CASSI_DISTURBED = 'CASSI_DISTURBED';
exports.CLOUD_SITE_PRODUCTS_DEACTIVATION = 'CLOUD_SITE_PRODUCTS_DEACTIVATION';
exports.COUPONS_READ = 'COUPONS_READ';
exports.COUPONS_WRITE = 'COUPONS_WRITE';
exports.STAFFID_LOGIN = 'STAFFID_LOGIN';
exports.EXPORT_CONTROLS_WRITE = 'EXPORT_CONTROLS_WRITE';
exports.UPDATE_ADD_ON_SUBSCRIPTIONS = 'UPDATE_ADD_ON_SUBSCRIPTIONS';
exports.DEAL_DESK = 'DEAL_DESK';
exports.FINANCE_USER = 'FINANCE_USER';
/* css-xp permission */
exports.BILL_TO_PRICING_ELIGIBILITY_WRITE = 'ac:bill-to-party/pricing-eligibility::write';
exports.BILL_TO_PARTY_WRITE = 'ac:bill-to-party::write';
exports.BILLING_ADMIN_MANAGE = 'ac:billing-admin::manage';
exports.BILLING_ADMIN_WRITE = 'ac:billing-admin::write';
exports.ENTITLEMENT_MANAGE = 'ac:entitlement-controller::manage';
exports.INVOICE_GROUP_WRITE = 'ac:invoice-group::write';
exports.PAYMENT_METHOD_DEFAULT_WRITE = 'ac:payment-method/isdefault::write';
exports.PAYMENT_METHOD_ON_TERM_WRITE = 'ac:payment-method/paymentterms::write';
exports.SHIP_TO_PARTY_WRITE = 'ac:ship-to-party::write';
exports.TRANSACTION_ACCOUNT_WRITE = 'ac:transacion-account::write';
exports.ADV_DEFAULT_BROWSER = 'css-xp:default:browse';
